// ProducerCompanyRegistration.jsx
import React from "react";

export default function ProducerCompanyRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Producer Company Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Producer Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Producer Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports Producer Company Registration for
            agricultural and producer groups, helping farmers and producer
            collectives form a dedicated corporate structure for their
            activities.
          </p>
          <p className="text-gray-700">
            From defining membership and governance to preparing incorporation
            documents and filings, the team assists producer groups in creating
            a compliant vehicle to market produce, access finance, and manage
            operations collectively.
          </p>
        </div>

        {/* Right: Square Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/2252482/pexels-photo-2252482.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Farmer producer group discussing producer company registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Producer Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps members and promoters of the producer
              company compile and organize the documents needed for a smooth
              incorporation process.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN card and address proof of all proposed members and
                  directors.
                </li>
                <li>
                  Identity proof of members and directors (Aadhaar, voter ID,
                  driving licence, or passport, as applicable).
                </li>
                <li>
                  Proof of producer activity for members, if required (such as
                  land records or relevant certificates).
                </li>
                <li>
                  Registered office address proof (utility bill, rent agreement
                  or property document, and NOC from owner where applicable).
                </li>
                <li>
                  Draft incorporation documents, including proposed Memorandum
                  and Articles of Association aligned with producer company
                  objectives.
                </li>
                <li>
                  Passport-size photographs and basic contact details of members
                  and directors.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused support to producer groups, combining
              knowledge of producer company law with an understanding of
              agriculture- and rural-focused governance needs.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Specialized Producer Company Knowledge
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on eligibility, member structure, and objects
                  specific to producer companies, ensuring the model suits
                  farmer and producer collectives.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Statutory Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in preparing incorporation forms and legal documents
                  in line with statutory requirements, helping avoid delays and
                  re-submissions.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end assistance from initial planning and documentation
                  to incorporation and post-registration guidance for ongoing
                  compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
